import { useMutation, type QueryClient } from '@tanstack/react-query';

import { deepClone } from '#packages/data-collection/utils/object';

import { APP_SETTINGS_QUERY_KEY } from '#apps/client-web/features/settings/types/react-query';
import { type AppSettingsService } from '#apps/client-web/features/settings/services/app-settings';
import { type AppSettings } from '#apps/client-web/features/settings/models/app-settings';

export const useSaveAppSettingsMutation = ({
  appSettingsService,
  queryClient,
}: {
  appSettingsService: AppSettingsService;
  queryClient: QueryClient;
}) =>
  useMutation(
    {
      mutationKey: [APP_SETTINGS_QUERY_KEY],
      mutationFn: (appSettings: AppSettings) =>
        appSettingsService.save(deepClone(appSettings)),
    },
    queryClient,
  );
